import React, { useState, useEffect, useCallback } from "react";
import { SetHeading } from "../../context/NavbarContext";
import { AutoComplete, Breadcrumb, Button, Input, Modal, Select } from "antd";
import {
  DoubleRightOutlined,
  DownOutlined,
  DownloadOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import ShimmerLoader from "../../loading";
import "../../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { routes } from "../../Routes";
import LoadingSpinner from "../../components/Loading";
import {
  getAllStoreProductInformation,
  getInventoryallproducts,
  getInventoryEditResttriction,
  getProductHistory,
  getProductInfo,
  getProductPurchaseInfo,
  getProductSaleInfo,
  getProductSalePurchaseInfo,
  getUOM,
  InventorySearchonboard,
  verifyInventoryPassword,
} from "../../API  Functions/InventoryFunctions";
import dummy_image from "../../assets/Images/gallery.svg";
import ProductPurchaseDetails from "./Tables/ProductPurchaseDetailsTable";
import ProductSaleDetailsTable from "./Tables/ProductSaleDetailsTable";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import SearchBox from "../CustomWidgets/SearchBox";
import AddPackageModal from "../../app/purchase/AddPackageModal";
import { URLS } from "../../API/API endpoints";
import axiosInstance from "../../AxiosInstance";
import { toast } from "react-toastify";
import ProductPackages from "./ProductPackages";
import AllStoreProductInfo from "./Tables/AllStoreProductInfoTable";
import { MultiSelectBox } from "../CustomWidgets/SelectBox";
import { getProductGroups } from "../../API  Functions/productGroupFunctions";
import Edit from "../../assets/Edit.svg";
import PasswordModal from "../../modals/PasswordModal";
import ProductHistoryTable from "./Tables/ProductHistoryTable";
import { GetRetailerDetails } from "../../API  Functions/ProfileFunctions";
import ExportCasInOutReportModal from "../../app/SessionHistory/ExportCasInOutReportModal";
import moment from "moment";
import ProductInfoExpire from "./Tables/ProductInfoExpire";
import InventoryValuationTable from "./Tables/InventoryValuationTable";
import UploadMediaonly from "../upload-imageonly";
import labelSample from "../../assets/35mm.png";
import JsBarcode from "jsbarcode";
import deleteicon from "../../assets/Order/Delete.svg";

const { RangePicker } = DatePicker;

const debounce = (func, delay) => {
  let timer;
  return function (...args) {
    const context = this;
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(context, args), delay);
  };
};

const ReadOnly = ({ label, value }) => {
  const { t, i18n } = useTranslation();

  return (
    <div>
      <p className="text-xs text-gray-500 mb-1">{t(label)}</p>
      <p className=" border-gray-300 pb-1">{value || "-"}</p>
    </div>
  );
};

const Editable = ({
  addCurrency,
  label,
  value,
  isEdit,
  onChange,
  readOnly,
  onKeyDown,
  ...props
}) => {
  const { t, i18n } = useTranslation();

  return (
    <div>
      <p className="text-xs text-gray-500 mb-1">{t(label)}</p>

      {isEdit && !readOnly ? (
        <input
          {...props}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full border-b border-gray-400 outline-none py-1"
          onKeyDown={onKeyDown}
        />
      ) : (
        <p className="border-b border-gray-300 pb-1">
          {addCurrency ? "EGP " : ""}
          {value || "-"}
        </p>
      )}
    </div>
  );
};

const GroupField = ({
  label,
  value,
  allGroups,
  isEdit,
  onChange,
  toggleDeliveryFrom,
  readOnly,
}) => {
  const { t, i18n } = useTranslation();
  const displayValue = Array.isArray(value)
    ? value.map((item) => item.name).join(", ")
    : value;

  return (
    <div>
      <p className="text-xs text-gray-500 mb-1">{t(label)}</p>

      {isEdit && !readOnly ? (
        <MultiSelectBox
          //   label={t("S")}
          name="groups"
          onChange={(event) => {
            console.log("categories==>", event.target.value);
            toggleDeliveryFrom(event.target.value);
          }}
          placeholder={t("Select Groups")}
          defaultValue={[
            ...value?.map((item) => ({
              value: item?.id,
              label: i18n.language == "ar" ? item?.name_ar : item?.name,
            })),
          ]}
          options={[
            ...allGroups?.map((item) => ({
              value: item?.id,
              label: i18n.language == "ar" ? item?.name_ar : item?.name,
            })),
          ]}
        />
      ) : (
        // <input
        //   value={displayValue}
        //   onChange={e => onChange(e.target.value)}
        //   className="w-full border-b border-gray-400 outline-none py-1"
        // />
        <p className="border-b border-gray-300 pb-1">{displayValue || "-"}</p>
      )}
    </div>
  );
};

const ProductInfo = () => {
  const { t, i18n } = useTranslation();
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const masterStore = useSelector((state) => state.login.masterStore);
  const { Option } = Select;
  const navigate = useNavigate();

  const [loading, setloading] = useState(false);
  const [searchloading, setSearchloading] = useState(false);
  const [showPurchase, setShowPurchase] = useState(false);
  const [showSale, setShowSale] = useState(false);
  const [isPackageOpen, setIsPackageOpen] = useState(false);
  const [productHistoryOpen, setProductHistoryOpen] = useState(false);
  const [searchid, setsearchid] = useState(localStorage.getItem("searchid"));
  const [prodDetail, setProdDetail] = useState({});
  const [allStoreProdDetail, setAllStoreProdDetail] = useState([]);
  const [purchaseData, setPurchasedata] = useState([]);
  const [productHistory, setProductHistory] = useState([]);
  const [saleData, setSaleData] = useState({});
  const [currentLimit, setCurrentLimit] = useState(10); // Default limit
  const [currentOffset, setCurrentOffset] = useState(0); // Default offset
  const [dateRange, setDateRange] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [secondBarcode, setSecondaryBarcode] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [value, setValue] = useState("");
  const [Productoptions, setProductoptions] = useState([]);
  const [allGroups, setAllGroups] = useState([]);
  const [searchByShortCode, setSearchByShortCode] = useState(false);
  const [openInventoryPasswordModal, setOpenInventoryPasswordModal] =
    useState(false);
  const [inventoryEditResriction, setInventoryEditResriction] = useState(false);
  const [isEtaEnable, setIsEtaEnable] = useState(null);
  const [vatTypes, setVatTypes] = useState([]);
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [existingExpiryData, setExistingExpiryData] = useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [editValues, setEditValues] = useState(null);
  const [isEnableGrams, setIsEnableGrams] = useState(false);
  const [isShowCostPrice, setIsShowCostPrice] = useState(true);
  const [masterPassword, setMasterPassword] = useState("");
  const [UOMs, setUOM] = useState([]);
  const [costingMethod, setCostingMethod] = useState("");
  const [base64Image, setBase64Images] = useState("");
  const [isFileValid, setIsFileValid] = useState(true);
  const [showlabelModal, setShowLabelModal] = useState(false);
  const [imageLoader, setImageLoader] = useState(false);
  const [numberOfprints, setNumberOfprints] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [showMarkQtyModal, setShowMarkQtyModal] = useState(false);
  const [markQtyLoading, setMarkQtyLoading] = useState(false);
  const [valuationReasons, setValuationReasons] = useState([]);
  const [valuationHistory, setValuationHistory] = useState([]);
  const [markQtyForm, setMarkQtyForm] = useState({
    mark_qty: "",
    reason: null,
    notes: "",
  });
  const userData = useSelector((state) => state?.login?.user?.result);
  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store,
  );
  const [taxId, setTaxId] = useState("");

  const EGS_PREFIX = `EG-${taxId}-`;

  const [formData, setFormData] = useState({
    name: prodDetail?.name,
    sale_price: prodDetail?.sale_price || "",
    cost_price: prodDetail?.cost_price || "",
    group: prodDetail?.group_list || "",
    groupId: prodDetail?.group_list
      ? prodDetail.group_list.map((item) => item.id)
      : [],
    custom_name: prodDetail?.product_name2 || "",
    quantity: prodDetail?.available_qty || "",
    short_code: prodDetail?.product_shortcut || "",
    weighing_code: prodDetail?.machine_barcode || "",
    egs_code: prodDetail?.egs_code || "",
    is_selling_gram: prodDetail?.egs_code || false,
    is_name_editable: prodDetail?.is_name_editable || false,
    prod_uom: null,
    prod_uom_name: prodDetail?.uom,
    minimum_shelf_qty: prodDetail?.minimum_shelf_qty,
    image_url: prodDetail?.image,
  });
  console.log("formData.image_url===>", formData?.image_url);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("Id");

    if (id) {
      localStorage?.setItem("prodId", id);
    }

    const searchparam = id || localStorage.getItem("prodId");
    setsearchid(searchparam);

    if (searchparam) {
      setloading(true);
      GetProductSecondaryCode(searchparam);
      getProdInfo(searchparam);
      // GetProductHistory(searchparam, 0, 20);
      // getPurchaseInfo(searchparam);
      getAllStoreProductInfo(searchparam);
      GetInventoryValuationHistory(searchparam, 10, 0);
    }
    // fetchdetails();
    //  GetVatTypes();
    CheckUserAcessForInventory();
  }, []);

  useEffect(() => {
    if (base64Image && isFileValid === false) {
      // getInventoryKPI();
      setBase64Images("");
      handleChange("image_url", "");
    }
  }, [isFileValid, base64Image]);

  const GetProductExpiryData = async (id, limit, offset) => {
    const payload = {
      company_id: company_id,
      product_id: Number(id),
      start_date: "",
      end_date: "",
      limit: limit,
      offset: offset,
    };
    try {
      const res = await axiosInstance.post(
        URLS.PRODUCT_EXPIRY_DETAILS,
        payload,
      );
      const res1 = res?.data;

      // console.log("res1---->", res1);

      if (res1?.result?.status_code === 200) {
        setExistingExpiryData(res1?.result?.data);
      } else {
        setExistingExpiryData([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      // setloading(false);
    } finally {
      // setloading(false);
    }
  };

  const GetValuationReasons = async () => {
    try {
      const res = await axiosInstance.post(
        URLS.GET_INVENTORY_VALUATION_REASON,
        {},
      );
      if (res?.data?.result?.status_code === 200) {
        setValuationReasons(res?.data?.result?.data || []);
      } else {
        setValuationReasons([]);
      }
    } catch (error) {
      console.error("Error fetching valuation reasons:", error);
      setValuationReasons([]);
    }
  };

  const GetInventoryValuationHistory = async (id, limit, offset) => {
    const payload = {
      company_id: company_id,
      product_id: Number(id),
      start_date: "",
      end_date: "",
      limit: limit,
      offset: offset,
    };
    try {
      const res = await axiosInstance.post(
        URLS.GET_INVENTORY_VALUATION,
        payload,
      );
      if (res?.data?.result?.status_code === 200) {
        setValuationHistory(res?.data?.result?.data || []);
      } else {
        setValuationHistory([]);
      }
    } catch (error) {
      console.error("Error fetching valuation history:", error);
      setValuationHistory([]);
    }
  };

  const handleMarkQtyChange = (key, value) => {
    setMarkQtyForm((prev) => ({ ...prev, [key]: value }));
  };

  const closeMarkQtyModal = () => {
    setShowMarkQtyModal(false);
    setMarkQtyForm({ mark_qty: "", reason: null, notes: "" });
  };

  const handleProcessMarkQty = async () => {
    if (!markQtyForm.mark_qty || Number(markQtyForm.mark_qty) <= 0) {
      toast.error(t("Enter a valid quantity"));
      return;
    }
    if (Number(markQtyForm.mark_qty) > Number(prodDetail?.available_qty)) {
      toast.error(t("Quantity cannot exceed available stock"));
      return;
    }
    if (!markQtyForm.reason) {
      toast.error(t("Select a reason"));
      return;
    }

    try {
      setMarkQtyLoading(true);
      const payload = {
        company_id: company_id,
        user_id: user_id,
        product_id: Number(searchid),
        system_qty: Number(prodDetail?.available_qty),
        mark_qty: Number(markQtyForm.mark_qty),
        reason_id: markQtyForm.reason,
        notes: markQtyForm.notes,
      };
      const response = await axiosInstance.post(
        URLS.CREATE_INVENTORY_VALUATION,
        payload,
      );
      if (response?.data?.result?.status_code === 200) {
        toast.success(t(response?.data?.result?.status));
        closeMarkQtyModal();
        getProdInfo(searchid);
        GetInventoryValuationHistory(searchid, 10, 0);
      } else {
        toast.error(t(response?.data?.result?.status));
      }
    } catch (error) {
      console.error("Error processing inventory valuation:", error);
    } finally {
      setMarkQtyLoading(false);
    }
  };

  const fetchdetails = () => {
    GetRetailerDetails(user_id).then((result) => {
      if (result) {
        setTaxId(
          result?.retailer_details?.tax_card_number
            ? result?.retailer_details?.tax_card_number
            : null,
        );
      }
    });
  };

  const GetVatTypes = async () => {
    const payload = {
      retailer_id: company_id,
      offset: 0,
      limit: 1000,
    };
    try {
      const res = await axiosInstance.post(URLS.GET_VAT_TYPES, payload);
      const res1 = res?.data;

      // console.log("res1---->", res1);

      if (res1?.result?.status_code === 200) {
        setVatTypes(res1?.result?.data?.filter((item) => item.is_active));
      } else {
        setVatTypes([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      // setloading(false);
    } finally {
      // setloading(false);
    }
  };

  const get_UOM = async () => {
    const res = await getUOM();

    if (res?.result?.[0].status == "UOM List")
      setUOM(res?.result?.[0]?.uom_list);
  };

  // useEffect(()=>{
  // },[])

  const GetProductHistory = (searchid, offset, limit) => {
    if (searchid) {
      getProductHistory(company_id, searchid, offset, limit).then((res) => {
        setloading(false);
        if (res?.status_code == 200) {
          setProductHistory(res?.response);
        } else {
          setProductHistory([]);
        }
      });
    }
  };

  const CheckUserAcessForInventory = async () => {
    try {
      const res = await getInventoryEditResttriction(
        masterStore?.user_id || user_id,
      );
      if (res?.result?.status_code == 200) {
        setInventoryEditResriction(res?.result?.restrict_cost_price);
        setMasterPassword(res?.result?.master_password);
        setIsShowCostPrice(res?.result?.is_show_cost_price);
        setIsEtaEnable(res?.result?.is_eta_enabled);
        setCostingMethod(res?.result?.costing_method);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const getProdInfo = (searchid) => {
    getProductInfo(company_id, searchid).then((datagot) => {
      setloading(false);
      if (datagot?.response?.categ_name == "NSP") {
        get_UOM();
      }
      setProdDetail(datagot?.response);
      console.log(datagot);
      setFormData({
        name: datagot?.response?.name,
        sale_price: datagot?.response?.sale_price || "",
        cost_price: datagot?.response?.cost_price || "",
        group: datagot?.response?.group_list || "",
        groupId: datagot?.response?.group_list
          ? datagot?.response?.group_list.map((item) => item.id)
          : [],
        custom_name: datagot?.response?.product_name2 || "",
        quantity: datagot?.response?.available_qty || "",
        short_code: datagot?.response?.product_shortcut || "",
        weighing_code: datagot?.response?.machine_barcode || "",
        egs_code: datagot?.response?.egs_code || "",
        is_selling_gram: datagot?.response?.is_selling_gram || false,
        is_name_editable: datagot?.response?.is_name_editable || false,
        prod_uom: null,
        prod_uom_name: datagot?.response?.uom,
        minimum_shelf_qty: datagot?.response?.minimum_shelf_qty,
        image_url: datagot?.response?.image,
      });
    });
  };

  const GetGroups = async () => {
    const payload = {
      lang: i18n.language === "ar" ? "ar_001" : "en_US",
      company_id: company_id,
      user_id: user_id,
      offset: 0,
      limit: 5000,
    };
    try {
      const res1 = await getProductGroups(payload);

      // console.log("res1---->", res1);

      if (res1?.result[0]?.status_code === 200) {
        setAllGroups(res1?.result[0]?.product_groups);
      } else {
        setAllGroups([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      // setloading(false);
    } finally {
      // setloading(false);
    }
  };

  const getAllStoreProductInfo = (searchid) => {
    getAllStoreProductInformation(company_id, searchid).then((datagot) => {
      setloading(false);
      console.log("ALL STOREEEE", datagot);

      setAllStoreProdDetail(datagot?.response || []);
    });
  };

  const getPurchaseInfo = (searchid, limit, offset) => {
    getProductSalePurchaseInfo(company_id, searchid, limit, offset).then(
      (datagot) => {
        setloading(false);
        setPurchasedata(datagot?.data || []);
      },
    );
  };

  // const handleRangePickerChange = (dates) => {
  //   if (dates && dates.length === 2) {
  //     const [start, end] = dates;
  //     const formattedStart = dayjs(start).format("YYYY-MM-DD");
  //     const formattedEnd = dayjs(end).format("YYYY-MM-DD");
  //     setDateRange([formattedStart, formattedEnd]);

  //     getPurchaseInfo(searchid, formattedStart, formattedEnd);
  //   } else {
  //     setDateRange([]);
  //     getPurchaseInfo(searchid, "", "");
  //   }
  // };

  // const handleVendorSearchChange = (value) => {
  //   setSearchText(value);
  //   getPurchaseInfo(searchid, dateRange[0], dateRange[1], value);
  // };

  const handleCustomerSearchChange = (value) => {
    setSearchText(value);
  };

  const GetProductSecondaryCode = async (id) => {
    const payload = {
      company_id: company_id,
      product_id: Number(id),
      user_id: user_id,
    };
    try {
      const response = await axiosInstance.post(
        URLS.GET_SECONDARY_BARCODE,
        payload,
      );

      if (response?.data?.result[0]?.status_code === 200) {
        setSecondaryBarcode(response?.data?.result[0]?.response[0]?.barcode);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };
  //   console.log("purchaseData", purchaseData);

  const UpdatePackages = async (prodId, packs) => {
    setloading(true);
    try {
      let payload = {
        product_id: Number(prodId),
        company_id: company_id,
        packages: packs,
      };
      const response = await axiosInstance.post(
        URLS.UPDATE_PRODUCT_PACKAGE,
        payload,
      );
      // console.log("GetAllPackages===>", response?.data);
      if (response?.data?.result?.status_code == 200) {
        setloading(false);
        //  setIsPackageModalOpen(false);
        toast.success(t("Packs updated successfully"));
      } else {
        toast.error(t(response?.data?.result?.status));
        // setPackagesArray([])
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    } finally {
      setloading(false);
    }
  };

  const handlePrintLabel = (item) => {
    if (!item) return;

    // === SIZE SETTINGS ===
    const labelWidth = 5; // cm
    const labelHeight = 2; // cm

    const labelHTML = `
    <div style="
      width: 10cm;
      height: 10cm;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 0;
      margin: 0;
      font-family: Arial;
    ">

      <!-- LEFT LABEL -->
      <div style="
        width: ${labelWidth}cm;
        height: ${labelHeight}cm;
        border: 1px dashed #000;
        text-align: center;
        padding: 2px;
        box-sizing: border-box;
      ">
        <img 
          src="https://barcode.tec-it.com/barcode.ashx?data=${item.barcode}&code=Code128"
          style="width: 90%; height: 50%; object-fit: contain;"
        />
        <div style="font-size: 10px; font-weight: bold; line-height: 1;">
          ${item.name}
        </div>
        <div style="font-size: 10px;">EGP ${item.sale_price}</div>
        <div style="font-size: 9px; margin-top: 2px;">${item.barcode}</div>
      </div>

      <!-- RIGHT LABEL (same item or blank) -->
      <div style="
        width: ${labelWidth}cm;
        height: ${labelHeight}cm;
        border: 1px dashed #000;
        text-align: center;
        padding: 2px;
        box-sizing: border-box;
      ">
        <img 
          src="https://barcode.tec-it.com/barcode.ashx?data=${item.barcode}&code=Code128"
          style="width: 90%; height: 50%; object-fit: contain;"
        />
        <div style="font-size: 10px; font-weight: bold; line-height: 1;">
          ${item.name}
        </div>
        <div style="font-size: 10px;">EGP ${item.sale_price}</div>
        <div style="font-size: 9px; margin-top: 2px;">${item.barcode}</div>
      </div>

    </div>
  `;

    // === CREATE HIDDEN IFRAME ===
    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(`
    <html>
      <head>
        <style>
          @page {
            size: 10cm 2cm;   /* Full sheet size */
            margin: 0;
          }
          body {
            margin: 0;
            padding: 0;
          }
        </style>
      </head>
      <body>${labelHTML}</body>
    </html>
  `);
    doc.close();

    // === PRINT AUTOMATICALLY ===
    iframe.contentWindow.focus();
    iframe.contentWindow.print();

    // Clean up
    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 1000);
  };

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  console.log("formData==>", formData);

  const verifyEgsCodeAPI = async (egsCode, prod_id) => {
    try {
      const body = {
        product_id: prod_id || 0, // if new product, send 0
        egs_code: egsCode,
        company_id,
      };

      const res = await axiosInstance.post(URLS.VERIFY_EGS_CODE, body);

      return res?.data;
      // Example expected: "Barcode already exists" or "Barcode available"
    } catch (error) {
      console.error("Error checking barcode:", error);
      return "error";
    }
  };

  const isValidEgsFilled = (egs) => {
    if (!egs) return false;
    if (egs === EGS_PREFIX) return false;
    return egs.length > EGS_PREFIX.length;
  };

  const handleSave = async () => {
    // API call here
    console.log("handleSave started");

    try {
      //   const oldEgs = prodDetail?.egs_code;
      // const newEgs = formData.egs_code;

      // const hadEgsBefore = isValidEgsFilled(oldEgs);
      // const hasEgsNow = isValidEgsFilled(newEgs);

      // // 👉 EGS entered now but wasn't there before
      // if (!hadEgsBefore && hasEgsNow) {
      //   try {
      //     const verifyRes = await verifyEgsCodeAPI(newEgs, Number(searchid));

      //     if (verifyRes?.result?.status_code !== 200) {
      //       toast.error(t("EGS code not verified"));
      //       setloading(false);
      //       return;
      //     }
      //   } catch (err) {
      //     toast.error(t("EGS code verification failed"));
      //     setloading(false);
      //     return;
      //   }
      // }
      // Sale price cannot be less than cost price
      if (
        costingMethod == "AVCO" &&
        (formData?.cost_price == "" || formData?.cost_price <= 0)
      ) {
        toast.error(t("Cost Price cannot be zero."));
        return;
      }
      if (
        formData?.sale_price !== "" &&
        formData?.cost_price !== "" &&
        Number(formData.sale_price) < Number(formData.cost_price)
      ) {
        toast.error(t("Sale price cannot be less than cost price"));
        return;
      }
      // Machine barcode must be exactly 7 digits OR empty
      if (formData?.weighing_code && !/^\d{7}$/.test(formData.weighing_code)) {
        toast.error(t("Weighing scale product code must be exactly 7 digits"));
        return;
      }
      console.log("Passed validations");

      setloading(true);
      const existingGroupIds = Array.isArray(formData?.group)
        ? formData.group.map((g) => g.id)
        : [];

      const removeGroupIds = existingGroupIds.filter(
        (id) => !formData.groupId.includes(id),
      );

      let payload = {
        product_name: formData?.name,
        product_id: Number(searchid),
        company_id: company_id,
        new_price: Number(formData?.sale_price),
        new_cost_price: Number(formData?.cost_price),
        machine_barcode: formData?.weighing_code,
        product_name2: formData?.custom_name,
        product_shortcut: formData?.short_code,
        new_quantity: Number(formData?.quantity),
        minimum_shelf_qty: Number(formData?.minimum_shelf_qty),
        add_group_ids: formData?.groupId || [],
        remove_group_ids: removeGroupIds,
        is_selling_gram: formData?.is_selling_gram,
        ...(prodDetail?.categ_name == "NSP" &&
          formData?.prod_uom && { uom_id: formData?.prod_uom }),
        image_url: formData?.image_url,
        // egs_code: formData?.egs_code,
      };

      console.log("Payload:", payload);

      console.log("Calling UPDATE_PRODUCT_INFO");
      const response = await axiosInstance.post(
        URLS.UPDATE_PRODUCT_INFO,
        payload,
      );

      console.log("Request promise:", response);

      // console.log("GetAllPackages===>", response?.data);
      if (response?.data?.result?.status_code == 200) {
        setIsEdit(false);
        getProdInfo(Number(searchid));
        // setloading(false);
        //  setIsPackageModalOpen(false);
        toast.success(t("Product updated successfully"));
      } else {
        toast.error(t(response?.data?.result?.status));
        // setPackagesArray([])
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    } finally {
      setloading(false);
    }
  };

  const searchResult = useCallback(
    debounce(async (value) => {
      const res = await getInventoryallproducts(
        user_id,
        company_id,
        false,
        false,
        value,
        10,
        0,
      );
      // console.log("API Response:", res);

      if (res?.result[0]?.response) {
        setSearchloading(false);
        setProductoptions(res.result[0].response);
      } else {
        setSearchloading(false);
        setProductoptions([]);
      }
    }, 500),
    [], // make sure this is not recreated on every render
  );

  const debouncedSearchbyCode = debounce(async (value) => {
    const productName = value === "" ? "" : value; // Set product_name as empty string if no value
    const limit = 10; // Set limit
    const offset = 0; // Set offset

    if (value === "") {
      // searchResult('');
    } else {
      let payload = {
        lang: i18n.language == "ar" ? "ar_001" : "en_US",
        short_code: productName,
        type: "all", //required // all or low or high or out
        company_id: company_id,
      };
      const response = await axiosInstance.post(
        URLS.GET_STOCK_BY_CODE,
        payload,
      );
      if (response?.data?.result[0]?.response) {
        setSearchloading(false);
        setProductoptions(response?.data?.result[0].response);
      } else {
        setSearchloading(false);
        setProductoptions([]);
      }
    }
  }, 1000);

  const resetProductEdit = () => {
    setIsEdit(false);
    console.log(prodDetail);
    setFormData({
      name: prodDetail?.name || "",
      sale_price: prodDetail?.sale_price || "",
      cost_price: prodDetail?.cost_price || "",
      group: prodDetail?.group_list || "",
      groupId: prodDetail?.group_list
        ? prodDetail?.group_list.map((item) => item.id)
        : [],
      custom_name: prodDetail?.product_name2 || "",
      quantity: prodDetail?.available_qty || "",
      short_code: prodDetail?.product_shortcut || "",
      weighing_code: prodDetail?.machine_barcode || "",
      egs_code: prodDetail?.egs_code || "",
      is_selling_gram: prodDetail?.is_selling_gram,
      is_name_editable: prodDetail?.is_name_editabale,
      prod_uom: null,
      prod_uom_name: prodDetail?.uom,
      minimum_shelf_qty: prodDetail?.minimum_shelf_qty,
      image_url: prodDetail?.response?.image,
    });
  };

  const closePasswordModal = () => {
    setFormData({
      name: prodDetail?.name || "",

      sale_price: prodDetail?.sale_price || "",
      cost_price: prodDetail?.cost_price || "",
      group: prodDetail?.group_list || "",
      groupId: prodDetail?.group_list
        ? prodDetail?.group_list.map((item) => item.id)
        : [],
      custom_name: prodDetail?.product_name2 || "",
      quantity: prodDetail?.available_qty || "",
      short_code: prodDetail?.product_shortcut || "",
      weighing_code: prodDetail?.machine_barcode || "",
      egs_code: prodDetail?.egs_code || "",
      is_selling_gram: prodDetail?.is_selling_gram,
      prod_uom: null,
      prod_uom_name: prodDetail?.uom,
      minimum_shelf_qty: prodDetail?.minimum_shelf_qty,
      image_url: prodDetail?.response?.image,
    });
    setIsEdit(false);
    setOpenInventoryPasswordModal(false);
  };

  const handlePasswordConfirm = async (password) => {
    try {
      // const res = await verifyInventoryPassword(user_id, password);
      if (password === masterPassword) {
        setOpenInventoryPasswordModal(false);
        handleSave();
      } else {
        toast.error(t("Invalid Password"));
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const handleExport = async (dates) => {
    let payload = {
      lang: i18n.language === "ar" ? "ar_001" : "en_US",
      // start_date: dates?.startDate,
      // end_date: dates?.endDate,
      product_id: searchid,
      company_id: company_id,
    };
    const response = await axiosInstance.post(
      URLS.GET_PRODUCT_HISTORY_EXCEL,
      payload,
    );
    console.log("handleExport", response);
    if (response?.data?.result?.status_code == 200) {
      setExportModalOpen(false);
      downloadFile(response?.data?.result?.file_base64);
    } else {
      toast.error(response?.data?.result.status);
    }
  };

  const downloadFile = (base64Data) => {
    try {
      if (
        !base64Data ||
        typeof base64Data !== "string" ||
        base64Data.trim() === ""
      ) {
        alert("No valid file data available for download");
        return;
      }

      let cleanBase64 = base64Data
        .trim()
        .replace(/^data:[\w/+-]+;base64,/, "")
        .replace(/^["']|["']$/g, "")
        .replace(/\s/g, "");

      const padLength = 4 - (cleanBase64.length % 4);
      if (padLength < 4) cleanBase64 += "=".repeat(padLength);

      let binaryString = atob(cleanBase64);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const header = new Uint8Array(bytes.buffer, 0, 8);
      let mimeType = "application/octet-stream";
      let fileExtension = "bin";

      if (header[0] === 0x50 && header[1] === 0x4b) {
        mimeType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        fileExtension = "xlsx";
      } else if (
        header[0] === 0xd0 &&
        header[1] === 0xcf &&
        header[2] === 0x11 &&
        header[3] === 0xe0
      ) {
        mimeType = "application/vnd.ms-excel";
        fileExtension = "xls";
      } else if (new TextDecoder().decode(header).includes(",")) {
        mimeType = "text/csv";
        fileExtension = "csv";
      }

      const blob = new Blob([bytes], { type: mimeType });
      // const timestamp = new Date()
      //   .toISOString()
      //   .replace(/[:.]/g, "-")
      //   .replace("T", "_")
      //   .slice(0, 19);
      // const filename = `inventory_sale_summary_${timestamp}.${fileExtension}`;
      const timestamp = moment().format("YYYY-MM-DD_HH.mm.ss"); // Using period for time
      const filename = `${t(
        "sale_purchase_summary",
      )}_${timestamp}.${fileExtension}`;

      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("File download failed:", error);
      alert(`Download failed: ${error.message || "Unknown error"}`);
    }
  };

  const handleProductUpdate = async () => {
    setOpenEditModal(false);
    try {
      let payload = {
        record_id: editValues?.id,
        is_delete: false,
        company_id: company_id,
        lot_number: editValues?.batchNumber,
        quantity: editValues?.qty,
        expiry_date: editValues?.expiryDate,
        manufacturing_date: editValues?.manufactureDate,
        shelf_life_days: editValues?.shelfLife,
      };
      const response = await axiosInstance.post(
        URLS.UPDATE_PRODUCT_EXPIRY,
        payload,
      );
      if (response?.data?.result?.status_code === 200) {
        toast.success(t("Product Expiry Updated Successfully"));
        // GetExpiryData("", 10, 0);
        GetProductExpiryData(searchid, 10, 0);
      } else {
        toast.error(t(response?.data?.result?.status));
      }
    } catch (error) {
      console.error("Error fetching expiry data:", error);
    } finally {
      setloading(false);
    }
  };

  const handleDeleteProduct = async (id, isDelete) => {
    Modal.confirm({
      title: t("Are you sure you want to remove this product?"),
      icon: <ExclamationCircleOutlined style={{ color: "#faad14" }} />,
      // content: t("This action cannot be undone."),
      okText: t("Yes"),
      cancelText: t("No"),
      okButtonProps: {
        className: "bg-primaryBlue hover:bg-primaryBlue text-white border-none",
      },
      onOk: async () => {
        let payload = {
          record_id: id,
          is_delete: isDelete ? true : false,
          company_id: company_id,
        };
        try {
          const response = await axiosInstance.post(
            URLS.UPDATE_PRODUCT_EXPIRY,
            payload,
          );
          if (response?.data?.result?.status_code === 200) {
            toast.success(t("Product Deleted Successfully"));
            GetProductExpiryData(searchid, 10, 0);
          } else {
            toast.error(t(response?.data?.result?.status));
          }
        } catch (error) {
          console.error("Error fetching expiry data:", error);
        } finally {
          setloading(false);
        }
      },
    });
  };

  const handleDeleteInventoryProduct = async (id, isDelete) => {
    let payload = {
      product_id: Number(searchid),
      company_id: company_id,
    };
    try {
      setDeleteLoading(true);
      const response = await axiosInstance.post(
        URLS.DELETE_INVENTORY_PRODUCT,
        payload,
      );
      if (response?.data?.result?.status_code === 200) {
        toast.success(t("Product Deleted Successfully"));
        navigate("/inventory");
      } else {
        toast.error(t(response?.data?.result?.status));
      }
    } catch (error) {
      console.error("Error fetching expiry data:", error);
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleChangeExpiry = (key, value) => {
    setEditValues((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  const generateBarcodeSVG = (value, options = {}) => {
    const svg = document.createElement("svg");
    JsBarcode(svg, value, {
      format: "CODE128",
      lineColor: "#000",
      height: options.height || 60,
      displayValue:
        options.displayValue !== undefined ? options.displayValue : true,
      fontSize: options.fontSize || 20,
      margin: 0,
    });
    return svg.outerHTML;
  };

  const handlePrintLabels35x24 = (isPrice) => {
    const barcodeSVG = generateBarcodeSVG(prodDetail.barcode);

    const labels = Array.from(
      { length: numberOfprints != "" ? numberOfprints : 1 },
      () => `
    <div class="label">
      <div class="product-name">${prodDetail.name}</div>
      ${barcodeSVG}
      ${
        isPrice
          ? `<div class="price">EGP ${Number(prodDetail.sale_price || 0).toFixed(2)}</div>`
          : ""
      }
    </div>
  `,
    ).join("");

    const htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8" />
      <title>Print Labels</title>
      <style>
        @page {
          size: 35mm 24mm;
          margin: 0;
        }

        body {
          margin: 0;
          padding: 0;
          font-family: Arial, sans-serif;
        }

        .label {
  width: 35mm;
  height: 24mm;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 1mm;
  page-break-after: always;
}

        .label:last-child {
          page-break-after: auto;
        }

       .label svg {
  width: 33mm;
  height: 10mm;
}

       .product-name {
  font-size: 2.7mm;
  overflow: hidden;
  display: flex;
  align-items: flex-end; /* bottom align text */
  flex: 1;              /* take remaining space */
   margin-bottom: 1mm;
}

       .price {
  font-size: 3mm;
  margin-top: 1mm;
}
      </style>
    </head>
    <body>
      ${labels}
    </body>
    </html>
  `;

    const printWindow = window.open("", "_blank");
    printWindow.document.write(htmlContent);
    printWindow.document.close();

    printWindow.onload = () => {
      printWindow.print();
      printWindow.close();
    };
  };
  return (
    <>
      {openInventoryPasswordModal === true && (
        <PasswordModal
          onCancel={closePasswordModal}
          onConfirm={handlePasswordConfirm}
        />
      )}
      {loading && <LoadingSpinner />}
      <div className="w-full flex flex-col md:h-full pb-2 overflow-y-auto  bg-[#F6F7F9]">
        <SetHeading value="inventory" />
        <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden mx-2 md:mx-0 md:ms-3">
          {loading ? (
            <ShimmerLoader />
          ) : (
            <>
              <div className="font-extrabold">
                <Breadcrumb
                  separator={<DoubleRightOutlined />}
                  items={[
                    {
                      title: (
                        <Link to={routes.inventory.root}>{t("inventory")}</Link>
                      ),
                      key: "inventory",
                    },
                    { title: t("Product Details") },
                  ]}
                  className="relative mt-3 font-semibold"
                />
              </div>

              <div className="flex flex-col md:flex-row items-end justify-between md:items-center mb-4 mt-4 md:me-5">
                <div className="flex items-center mt-2 w-full md:w-6/12 md:pe-5">
                  {/* <h2 className="text-xs font-medium">{"Search Products"}</h2> */}
                  <div className="relative me-2 w-9/12">
                    <AutoComplete
                      value={value}
                      options={Productoptions.map((option) => ({
                        value: option.quant_id,
                        label:
                          option.product_name2 && option.product_name2 != ""
                            ? option.product_name2
                            : option.product_name,
                      }))}
                      onSearch={(value) => {
                        // if (!isProductSelected) {
                        setValue(value);
                        if (searchByShortCode) {
                          debouncedSearchbyCode(value);
                          setSearchloading(true);
                        } else {
                          if (value.length >= 3) {
                            setSearchloading(true);
                            searchResult(value);
                          } else {
                            setProductoptions([]);
                            setSearchloading(true);
                          }
                        }

                        // }
                      }}
                      onSelect={(value) => {
                        console.log("valllll=>", value);

                        setloading(true);
                        setsearchid(value);
                        GetProductSecondaryCode(value);
                        getProdInfo(value);
                        getPurchaseInfo(value, 10, 0);
                        GetProductExpiryData(value, 10, 0);
                        getAllStoreProductInfo(value);
                        GetInventoryValuationHistory(value, 10, 0);
                        setProductoptions([]);
                        setValue("");
                        setIsEdit(false);
                        // setProductoptions([]);
                      }}
                      style={{ width: "100%", height: "38px" }}
                      className=""
                      placeholder={t("search_product")}
                      // readOnly={isProductSelected}
                      // disabled={isAddBarcodeModalOpen}
                    />
                    {searchloading && (
                      <div
                        className={`absolute ${
                          i18n.language === "ar" ? "left-8" : "right-8"
                        } top-3 flex items-center`}
                      >
                        <svg
                          className="animate-spin h-4 w-4 text-gray-500"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                          />
                        </svg>
                      </div>
                    )}
                    {value && (
                      <button
                        type="button"
                        onClick={() => {
                          setValue(""); // Clear the input value
                          setProductoptions([]);
                        }}
                        className={`absolute ${
                          i18n.language === "ar" ? "left-2" : "right-2"
                        } top-2 text-gray-500 hover:text-gray-700`}
                        // className="absolute right-2 top-2 text-gray-500 hover:text-gray-700"
                      >
                        &times;
                      </button>
                    )}
                  </div>
                  <button
                    type="button"
                    onClick={() => {
                      setValue("");
                      setProductoptions([]);
                      setSearchByShortCode(!searchByShortCode);
                    }}
                    className={`h-[40px] items-end md:items-center px-2 rounded-md border text-sm whitespace-nowrap
    ${
      searchByShortCode
        ? "bg-blue-100 border-primaryBlue text-primaryBlue"
        : "bg-white border-gray-300 text-gray-700"
    }`}
                  >
                    {t("Search Code")}
                  </button>
                </div>
                <div className="flex gap-x-2 items-center">
                  <button
                    onClick={() => {
                      setNumberOfprints("");
                      setShowLabelModal(true);
                    }}
                    className="flex items-center gap-1.5 px-3 h-8 bg-[#7EC242] text-white text-sm font-semibold rounded-lg"
                  >
                    {t("Print Labels")}
                  </button>
                  {!allStores && (
                    <button
                      onClick={() => {setShowMarkQtyModal(true)
                GetValuationReasons();

                      }}
                      className="flex items-center gap-1.5 px-3 h-8 bg-[#F59E0B] text-white text-sm font-semibold rounded-lg"
                    >
                      {t("Mark Missing/Damaged")}
                    </button>
                  )}
                  {!allStores && (
                    <>
                      {!isEdit ? (
                        <div
                          onClick={() => {
                            setIsEdit(true);
                            GetGroups();
                          }}
                          className="w-9 h-9 border rounded-lg flex items-center justify-center hover:bg-gray-100 mt-2 md:mt-0"
                        >
                          <img
                            src={Edit}
                            style={{
                              cursor: "pointer",
                              height: "1rem",
                              width: "1rem",
                            }}
                            alt="Edit"
                          />
                        </div>
                      ) : (
                        <div className="flex mt-2 md:mt-0">
                          <button
                            onClick={resetProductEdit}
                            className="px-6 py-2 me-2 border border-primaryBlue bg-white text-primaryBlue rounded-lg text-sm font-semibold"
                          >
                            {t("Cancel")}
                          </button>
                          <button
                            onClick={() => {
                              const isPriceChanged =
                                Number(formData?.quantity) !==
                                  Number(prodDetail?.available_qty) ||
                                Number(formData?.sale_price) !==
                                  Number(prodDetail?.sale_price) ||
                                Number(formData?.cost_price) !==
                                  Number(prodDetail?.cost_price);

                              if (inventoryEditResriction && isPriceChanged) {
                                setOpenInventoryPasswordModal(true);

                                // block save (show error / modal / toast)
                                // example:
                                // toast.error("You are not allowed to change price or quantity");
                              } else {
                                handleSave();
                              }
                            }}
                            disabled={imageLoader}
                            className="px-6 py-2 bg-primaryBlue text-white rounded-lg text-sm font-semibold disabled:opacity-50"
                          >
                            {t("Save")}
                          </button>
                        </div>
                      )}
                    </>
                  )}
{!userData?.is_sub_store && !userData?.is_warehouse && !allStores && 
<div
                    onClick={() => {
                      if(prodDetail?.is_deletable){
                      setShowConfirmModal(true);
                      }else{
                        toast.error(t('This product cannot be deleted because it has purchase or sales transactions associated with it.'))
                      }
                    }}
                    className={`w-9 h-9 border rounded-lg flex items-center cursor-pointer justify-center hover:bg-gray-100 mt-2 md:mt-0`}
                  >
                    <img
                      src={deleteicon}
                      className="cursor-pointer h-4 w-4 mx-2"
                      alt="Delete"
                    />
                  </div>
}
                  
                </div>
              </div>
              <div className="bg-white rounded-lg shadow-md p-6">
                {/* Top section (READ ONLY) */}

                <div className="flex flex-col md:flex-row gap-4 md:gap-8 mb-8 items-center">
                  <div className="w-56 h-80 border rounded-lg flex items-center flex-col justify-center overflow-hidden px-2 py-4">
                    {imageLoader ? (
                      <div className="flex items-center justify-center w-full h-52">
                        <div className="w-8 h-8 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
                      </div>
                    ) : (
                      <>
                        {base64Image ? (
                          <img
                            src={base64Image}
                            alt=""
                            className="object-contain w-full h-52"
                          />
                        ) : prodDetail?.image ? (
                          <img
                            src={prodDetail?.image || dummy_image}
                            className="object-contain w-full h-52"
                          />
                        ) : (
                          <svg
                            className=" float-left h-10 w-12 text-gray-300"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z"
                            />
                          </svg>
                        )}
                        {isEdit && (
                          <span className="cursor-pointer mt-5">
                            <UploadMediaonly
                              foldername={"store_image"}
                              onfileAdd={`prod-img-${searchid}`}
                              setBase64Images={setBase64Images}
                              urlgenerated={(val) =>
                                handleChange("image_url", val?.url)
                              }
                              imageurl={
                                formData?.image_url == undefined
                                  ? ""
                                  : formData?.image_url
                              }
                              setIsFileValid={setIsFileValid}
                              setImageLoading={setImageLoader}
                              isCrop={true}
                            />
                          </span>
                        )}
                      </>
                    )}
                  </div>
                  <div className="flex-1 ">
                    {prodDetail?.is_name_editable ? (
                      <div className="mb-4 ">
                        <Editable
                          label="Product name"
                          value={formData?.name || formData?.prod_name}
                          isEdit={isEdit}
                          onChange={(l) => {
                            handleChange("name", l);
                          }}
                        />
                      </div>
                    ) : (
                      <h2 className="text-xl font-semibold mb-3">
                        {prodDetail?.name}
                      </h2>
                    )}

                    <div className="grid grid-cols-2 md:grid-cols-3 gap-x-4 md:gap-x-12 gap-y-6 ">
                      <ReadOnly label="Barcode" value={prodDetail?.barcode} />
                      {/* <ReadOnly label="EGS Code" value={prodDetail?.egs_code} /> */}
                      <ReadOnly
                        label="Category"
                        value={prodDetail?.categ_name}
                      />
                      <ReadOnly
                        label="Sub Category"
                        value={prodDetail?.sub_categ_name}
                      />
                      <ReadOnly
                        label="Current Stock Value"
                        value={`EGP ${(prodDetail?.cost_price * prodDetail?.available_qty)?.toFixed(2)}`}
                      />
                      {prodDetail?.categ_name != "NSP" && (
                        <ReadOnly label="Product Uom" value={prodDetail?.uom} />
                      )}
                      <ReadOnly
                        label="First added on"
                        value={prodDetail?.addon_date}
                      />
                      <ReadOnly
                        label="Last updated on"
                        value={prodDetail?.last_update_date}
                      />
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-x-4 md:gap-x-12 gap-y-6 mt-5">
                      {isShowCostPrice && (
                        <Editable
                          addCurrency={true}
                          label="Cost Price"
                          value={formData.cost_price}
                          isEdit={isEdit}
                          onChange={(v) => {
                            if (
                              /^\d*(\.\d{0,2})?$/.test(v) &&
                              (v === "" || Number(v) <= 100000)
                            ) {
                              handleChange("cost_price", v);
                            }
                          }}
                        />
                      )}

                      <Editable
                        addCurrency={true}
                        label="Sale Price"
                        value={formData.sale_price}
                        isEdit={isEdit}
                        onChange={(v) => {
                          if (
                            /^\d*(\.\d{0,2})?$/.test(v) &&
                            (v === "" || Number(v) <= 100000)
                          ) {
                            handleChange("sale_price", v);
                          }
                        }}
                      />

                      <Editable
                        label="Quantity"
                        value={formData.quantity}
                        isEdit={isEdit}
                        onChange={(v) => {
                          if (
                            /^\d*(\.\d{0,2})?$/.test(v) &&
                            (v === "" || Number(v) <= 100000)
                          ) {
                            handleChange("quantity", v);
                          }
                        }}
                      />
                      <Editable
                        label="Minimum Stock Quantity"
                        value={formData.minimum_shelf_qty}
                        isEdit={isEdit}
                        onChange={(v) => {
                          if (
                            /^\d*(\.\d{0,2})?$/.test(v) &&
                            (v === "" || Number(v) <= 100000)
                          ) {
                            handleChange("minimum_shelf_qty", v);
                          }
                        }}
                      />
                      <Editable
                        label="Custom Product Name"
                        readOnly={
                          userData?.is_sub_store || userData?.is_warehouse
                        }
                        value={formData.custom_name}
                        isEdit={isEdit}
                        onChange={(v) => {
                          handleChange("custom_name", v);
                          // if (v.length <= 50) {
                          //   handleChange("custom_name", v);
                          // }
                        }}
                      />
                      {/* <Editable
                        label="EGS Code"
                        readOnly={
                          userData?.is_sub_store || userData?.is_warehouse
                        }
                        value={
                            formData.egs_code?.startsWith(EGS_PREFIX)
                              ? formData.egs_code
                              : EGS_PREFIX
                          }
                        isEdit={isEdit}
                        maxLength={30}
                          onChange={(value) => {
                            // let value = event.target.value;

                            // If user tries to delete prefix, restore it
                            if (!value.startsWith(EGS_PREFIX)) {
                              value = EGS_PREFIX;
                            }

                            // Allow only digits after prefix
                            const suffix = value
                              .slice(EGS_PREFIX.length)
                              .replace(/[^0-9]/g, "");

                            handleChange(
                              "egs_code",
                              EGS_PREFIX + suffix,
                            );
                          }}
                          onKeyDown={(e) => {
                            const cursorPosition = e.target.selectionStart;

                            // Prevent backspace/delete inside prefix
                            if (
                              (e.key === "Backspace" || e.key === "Delete") &&
                              cursorPosition <= EGS_PREFIX.length
                            ) {
                              e.preventDefault();
                            }
                          }}
                      /> */}
                      <Editable
                        label="Product Short Code"
                        readOnly={
                          userData?.is_sub_store || userData?.is_warehouse
                        }
                        value={formData.short_code}
                        isEdit={isEdit}
                        onChange={(v) => {
                          if (/^\d*$/.test(v) && v.length <= 10) {
                            handleChange("short_code", v);
                          }
                        }}
                      />

                      <Editable
                        label="Weighing Scale Product Code"
                        readOnly={
                          userData?.is_sub_store ||
                          userData?.is_warehouse ||
                          prodDetail?.uom == "Units" ||
                          prodDetail?.uom == "Bundle" ||
                          prodDetail?.uom == "الوحدات"
                        }
                        value={formData.weighing_code}
                        isEdit={isEdit}
                        onChange={(v) => {
                          if (/^\d*$/.test(v) && v.length <= 7) {
                            handleChange("weighing_code", v);
                          }
                        }}
                      />

                      <GroupField
                        label="Product Groups"
                        value={formData.group}
                        readOnly={
                          userData?.is_sub_store || userData?.is_warehouse
                        }
                        isEdit={isEdit}
                        allGroups={allGroups}
                        // onChange={v => handleChange("group", v)}
                        toggleDeliveryFrom={(v) => handleChange("groupId", v)}
                      />
                      {prodDetail?.categ_name == "NSP" && (
                        <>
                          {isEdit ? (
                            <div>
                              <p className="text-xs text-gray-500 mb-2">
                                {t("Product Uom")}
                              </p>
                              <Select
                                className="overflow-hidden me-3"
                                style={{
                                  width: "100%",
                                  minWidth: 200,
                                  height: 40,
                                }}
                                placeholder={t("Select Uom")}
                                value={formData?.prod_uom_name} // ✅ use id here
                                onChange={(val) => {
                                  const selected = Object.values(UOMs).find(
                                    (item) => item.uom_id === val,
                                  );

                                  handleChange("prod_uom", val);
                                  handleChange(
                                    "prod_uom_name",
                                    t(selected?.uom_name),
                                  );
                                }}
                              >
                                {Object.values(UOMs)?.map((option) => (
                                  <Option
                                    key={option?.uom_id}
                                    value={option?.uom_id}
                                  >
                                    {t(option?.uom_name)}
                                  </Option>
                                ))}
                              </Select>
                            </div>
                          ) : (
                            <Editable
                              label="Product Uom"
                              value={prodDetail?.uom}
                              isEdit={false}
                            />
                          )}
                        </>
                      )}

                      {(prodDetail?.uom == "KG" ||
                        prodDetail?.uom == "كجم") && (
                        <div className=" flex gap-x-2 items-center mt-4">
                          <p className="text-sm font-medium">
                            {t("Sell in Grams")}
                          </p>
                          <label className="flex cursor-pointer select-none items-center me-7">
                            <div className="relative">
                              <input
                                type="checkbox"
                                checked={formData?.is_selling_gram}
                                onChange={() =>
                                  handleChange(
                                    "is_selling_gram",
                                    !formData.is_selling_gram,
                                  )
                                }
                                className="sr-only"
                                disabled={!isEdit}
                              />
                              <div
                                className={`box block h-6 w-12 rounded-full ${
                                  formData?.is_selling_gram
                                    ? "bg-green-500"
                                    : "bg-gray-500"
                                }`}
                              ></div>
                              <div
                                className={`absolute left-1 top-1 flex h-4 w-5 items-center justify-center rounded-full bg-white transition ${
                                  formData?.is_selling_gram
                                    ? "translate-x-full"
                                    : ""
                                }`}
                              ></div>
                            </div>
                          </label>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Divider */}
                {/* <div className="border-t my-6" /> */}

                {/* Editable section (BOTTOM ONLY) */}
              </div>

              {(prodDetail?.uom === "Units" ||
                prodDetail?.uom === "الوحدات") && (
                <div className="mt-6 bg-white rounded-lg flex flex-col items-start">
                  <div className="flex justify-between items-center px-4 ">
                    <button
                      onClick={() => setIsPackageOpen(!isPackageOpen)}
                      className="flex items-center gap-2 text-black px-4 py-4 text-lg font-semibold rounded  transition-all"
                    >
                      {t("Packages")}
                      <DownOutlined
                        className={`transition-transform duration-300 ${
                          isPackageOpen ? "rotate-180" : "rotate-0"
                        }`}
                      />
                    </button>
                  </div>

                  {isPackageOpen && (
                    <ProductPackages
                      onClose={() => {
                        setIsPackageOpen(false);
                      }}
                      productId={Number(searchid)}
                      savedPackages={null}
                      onSavePackages={UpdatePackages}
                      prodDetail={prodDetail}
                    />
                  )}
                </div>
              )}

              {allStores && (
                <div className="mt-6 bg-white rounded-lg">
                  <br></br>
                  <div className="font-semibold text-lg ms-5 ">
                    {t("Store-Wise Product Details")}
                  </div>
                  <AllStoreProductInfo
                    additionalData={allStoreProdDetail}
                    handleReferesh={() => getAllStoreProductInfo(searchid)}
                    // pagination={(values) => {
                    //   setCurrentLimit(values.limit);
                    //   setCurrentOffset(values.offset);
                    //   getAllStoreProductInfo(
                    //     company_id,
                    //     searchid
                    //     // values.limit,
                    //     // values.offset
                    //   );
                    // }}
                  />
                </div>
              )}

              <div className="mt-6 bg-white rounded-lg">
                <br></br>
                <div className="flex justify-between items-center">
                  <div className="font-semibold text-lg ms-5 ">
                    {t("Sales & Purchases Summary")}
                  </div>
                  <div className=" flex justify-end mx-8">
                    <button
                      className="w-48 h-10 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center gap-2"
                      // onClick={() => setExportModalOpen(true)}
                      onClick={() => {
                        handleExport();
                      }}
                    >
                      <DownloadOutlined
                        style={{ fontSize: "1.5em", MozMarginStart: -10 }}
                      />

                      <span>{t("Download in Excel")}</span>
                    </button>
                  </div>
                </div>
                <ProductPurchaseDetails
                  additionalData={purchaseData}
                  pagination={(values) => {
                    // setCurrentLimit(values.limit);
                    // setCurrentOffset(values.offset);
                    getPurchaseInfo(searchid, values.limit, values.offset);
                  }}
                />
              </div>

              <div className="mt-6 bg-white rounded-lg">
                <br></br>
                <div className="font-semibold text-lg ms-5 ">
                  {t("Product Expiry")}
                </div>
                <ProductInfoExpire
                  additionalData={existingExpiryData}
                  pagination={(values) => {
                    // setCurrentLimit(values.limit);
                    // setCurrentOffset(values.offset);
                    GetProductExpiryData(searchid, values.limit, values.offset);
                  }}
                  onDelete={(id) => handleDeleteProduct(id, true)}
                  onEditLine={(line) => {
                    let data = {
                      id: line?.id,
                      qty: line?.quantity,
                      batchNumber: line?.lot_number ? line?.lot_number : "",
                      manufactureDate: line?.manufacturing_date
                        ? dayjs(line?.manufacturing_date)
                        : null,
                      shelfLife: line?.shelf_life_days
                        ? line?.shelf_life_days
                        : "",
                      expiryDate: line?.expiry_date
                        ? dayjs(line?.expiry_date)
                        : null,
                    };
                    setEditValues(data);
                    setOpenEditModal(true);
                  }}
                />
              </div>

              <div className="mt-6 bg-white rounded-lg">
                <br></br>
                <div className="font-semibold text-lg ms-5 ">
                  {t("Inventory Valuation History")}
                </div>
                <InventoryValuationTable
                  additionalData={valuationHistory}
                  pagination={(values) => {
                    GetInventoryValuationHistory(
                      searchid,
                      values.limit,
                      values.offset,
                    );
                  }}
                />
              </div>

              {/* <div className="mt-6 bg-white rounded-lg mb-5">

  <div
    onClick={() => setProductHistoryOpen(!productHistoryOpen)}
    className="flex items-center px-5 py-4 cursor-pointer "
  >
    <span className="font-semibold text-lg">
      {t("Product History")}
    </span>

    <DownOutlined
      className={`transition-transform duration-300 text-gray-600 ms-2 ${
        productHistoryOpen ? "rotate-180" : "rotate-0"
      }`}
    />
  </div>

  {productHistoryOpen && (
    <ProductHistoryTable
      additionalData={productHistory}
      pagination={(values) => {
        GetProductHistory(searchid, values.offset, values.limit);
      }}
    />
  )}

</div> */}
              <div>
                {productHistoryOpen && (
                  <ProductHistoryTable
                    additionalData={productHistory}
                    pagination={(values) => {
                      GetProductHistory(searchid, values.offset, values.limit);
                    }}
                  />
                )}
              </div>
            </>
          )}
        </div>
        {/* {exportModalOpen && (
        <ExportCasInOutReportModal
          heading={t("Download Sales & Purchases Summary")}
          isOpen={exportModalOpen}
          onClose={() => setExportModalOpen(false)}
          onExport={(dates) => handleExport(dates)}
        />
      )} */}

        <Modal
          open={showConfirmModal}
          onCancel={() => setShowConfirmModal(false)}
          footer={null}
          centered
          closable={false}
        >
          <div className="text-center p-6">
            <h3 className="text-lg font-semibold mb-4 text-gray-800">
              {t("Are you sure you want to delete this product ?")}
            </h3>
            <div className="flex justify-center gap-4 mt-6">
              <button
                onClick={() => setShowConfirmModal(false)}
                className="px-6 py-2 rounded-lg border border-gray-300 hover:bg-gray-100 text-gray-700 font-semibold"
              >
                {t("No")}
              </button>
              <button
                onClick={() => handleDeleteInventoryProduct()} // ✅ fixed line
                disabled={deleteLoading}
                className="px-6 py-2 rounded-lg bg-[#FF1616] hover:bg-[#e01414] text-white font-semibold"
              >
                {deleteLoading ? t("Removing...") : t("Yes")}
              </button>
            </div>
          </div>
        </Modal>

        <Modal
          title={t("Expiry")}
          visible={openEditModal}
          onCancel={() => {
            setEditValues(null);
            setOpenEditModal(false);
          }}
          footer={null}
          width={850}
        >
          <div className="expiry-page">
            <div className="flex mb-2 gap-2 flex-wrap">
              <Input
                type="number"
                placeholder={t("Qty")}
                value={editValues?.qty}
                onChange={(e) => handleChangeExpiry("qty", e.target.value)}
                onWheel={(e) => e.target.blur()}
                min={0}
                style={{ width: "90px" }}
                disabled={true}
              />
              <Input
                placeholder={t("Batch Number")}
                value={editValues?.batchNumber}
                onChange={(e) =>
                  handleChangeExpiry("batchNumber", e.target.value)
                }
                style={{ width: "140px" }}
                disabled={!editValues?.qty}
              />

              <DatePicker
                placeholder={t("Manufacture Date")}
                value={editValues?.manufactureDate}
                onChange={(date) => handleChangeExpiry("manufactureDate", date)}
                style={{ width: "190px" }}
                disabled={!editValues?.qty || editValues?.expiryDate}
              />

              <Input
                type="number"
                placeholder={t("Shelf Life (Days)")}
                value={editValues?.shelfLife}
                onChange={(e) =>
                  handleChangeExpiry("shelfLife", e.target.value)
                }
                min={0}
                style={{ width: "140px" }}
                disabled={
                  !editValues?.manufactureDate ||
                  !editValues?.qty ||
                  editValues?.expiryDate
                }
              />

              <DatePicker
                placeholder={t("Expiry Date")}
                value={editValues?.expiryDate}
                onChange={(date) => {
                  handleChangeExpiry("shelfLife", "");
                  handleChangeExpiry("expiryDate", date);
                }}
                style={{ width: "190px" }}
                disabled={!editValues?.qty || editValues?.manufactureDate}
              />
            </div>

            <div className="flex justify-end font-semibold mt-4">
              <Button
                onClick={handleProductUpdate}
                className="bg-primaryBlue hover:bg-primaryBlue"
                type="primary"
                // disabled={isButtonDisabled}
              >
                {t("save")}
              </Button>
            </div>
          </div>
        </Modal>
        <Modal
          title={t("Mark Quantity")}
          open={showMarkQtyModal}
          onCancel={closeMarkQtyModal}
          footer={null}
        >
          <div className="flex flex-col gap-4">
            <div>
              <p className="text-xs text-gray-500 mb-1">
                {t("Available Quantity")}
              </p>
              <p className="border-b border-gray-300 pb-1">
                {prodDetail?.available_qty ?? "-"}
              </p>
            </div>

            <div>
              <p className="text-xs text-gray-500 mb-1">{t("Quantity")}</p>
              <Input
                type="number"
                placeholder={t("Enter Quantity")}
                value={markQtyForm.mark_qty}
                onChange={(e) => {
                  const value = e.target.value;
                  const isUnit =
                    prodDetail?.uom === "Units" ||
                    prodDetail?.uom === "Bundle" ||
                    prodDetail?.uom === "الوحدات";
                  const regex = isUnit ? /^\d*$/ : /^\d*(\.\d{0,2})?$/;
                  if (regex.test(value)) {
                    handleMarkQtyChange("mark_qty", value);
                  }
                }}
                onWheel={(e) => e.target.blur()}
                min={0}
              />
            </div>

            <div>
              <p className="text-xs text-gray-500 mb-1">{t("Reason")}</p>
              <Select
                style={{ width: "100%" }}
                placeholder={t("Select Reason")}
                value={markQtyForm.reason}
                onChange={(val) => handleMarkQtyChange("reason", val)}
                options={valuationReasons?.map((item) => ({
                  value: item?.id,
                  label:
                    i18n.language == "ar"
                      ? item?.name_ar || item?.name
                      : item?.name,
                }))}
              />
            </div>

            <div>
              <p className="text-xs text-gray-500 mb-1">{t("Notes")}</p>
              <Input.TextArea
                placeholder={t("Enter Notes")}
                value={markQtyForm.notes}
                onChange={(e) =>
                  handleMarkQtyChange("notes", e.target.value)
                }
                rows={3}
                maxLength={100}
              />
            </div>

            <div className="flex justify-end gap-2 mt-2">
              <button
                onClick={closeMarkQtyModal}
                className="px-6 py-2 border border-primaryBlue bg-white text-primaryBlue rounded-lg text-sm font-semibold"
              >
                {t("Cancel")}
              </button>
              <button
                onClick={handleProcessMarkQty}
                disabled={markQtyLoading}
                className="px-6 py-2 bg-primaryBlue text-white rounded-lg text-sm font-semibold disabled:opacity-50"
              >
                {markQtyLoading ? t("Processing...") : t("Process")}
              </button>
            </div>
          </div>
        </Modal>

        {showlabelModal && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl p-8 w-[520px] shadow-2xl text-center relative">
              <button
                className="absolute top-3 right-3 text-gray-600 hover:text-black text-2xl"
                onClick={() => setShowLabelModal(false)}
              >
                ×
              </button>

              {/* Label size sample image */}
              <div className="flex justify-center mb-4">
                <img
                  src={labelSample}
                  alt="Label size example"
                  className="w-72 rounded-lg border"
                />
              </div>

              <>
                <p className="text-base text-gray-700 mb-4">
                  {t("Your labels are sized 35mm × 24mm as shown above.")}
                </p>

                <div className="mb-5 text-left">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {t("Number of labels to print. (Max 999)")}
                  </label>
                  <input
                    type="text"
                    inputMode="numeric"
                    maxLength={3}
                    value={numberOfprints}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      setNumberOfprints(value);
                    }}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none"
                    placeholder={t("1")}
                  />
                </div>

                <h2 className="text-xl font-semibold mb-6">
                  {t("Do you want to print product price also?")}
                </h2>

                <div className="flex justify-between mt-4">
                  <button
                    className="px-6 py-3 bg-gray-300 rounded-lg w-32 text-lg font-medium"
                    onClick={() => {
                      setShowLabelModal(false);
                      handlePrintLabels35x24(false);
                    }}
                  >
                    {t("No")}
                  </button>

                  <button
                    className="px-6 py-3 bg-primaryBlue text-white rounded-lg w-32 text-lg font-medium"
                    onClick={() => {
                      setShowLabelModal(false);
                      handlePrintLabels35x24(true);
                    }}
                  >
                    {t("Yes")}
                  </button>
                </div>
              </>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ProductInfo;
